<template>
<w-sliding-popup ref="slidingPopup" type="setting" title="에이전트 설정 수정" @close="onClose" width="500px">
  <div slot="content">
    <el-form :model="settingFormData" label-position="top" ref="settingForm">
      <div class="title-h4">설정 정보</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="적용" prop="includeConfig">
            <el-switch v-model="settingFormData.includeConfig" :active-value="true" :inactive-value="false" @change="changeIncludeConfig" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="활성화" prop="enableConfig">
            <el-switch v-model="settingFormData.enableConfig" :disabled="!settingFormData.includeConfig" :active-value="true" :inactive-value="false" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="설정유형" prop="configType">
            <el-input v-model="settingFormData.configType" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="설정ID" prop="configId">
            <el-input v-model="settingFormData.configId" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="설정내용" prop="configDesc">
          <el-input v-model="settingFormData.configDesc" :disabled="true" />
        </el-form-item>
      </el-row>
      <!-- <el-row v-if="settingFormData.settingValue === 'true' || settingFormData.settingValue === 'false' || switchFlag === true"> -->
      <el-row v-if="isBoolean(settingFormData.settingValue) || isBoolean(settingFormData.defaultValue)">
        <el-form-item label="기본 값" prop="defaultValue">
          <el-switch v-model="settingFormData.defaultValue" :disabled="true" />
        </el-form-item>
      </el-row>
      <el-row v-else>
        <el-form-item label="기본 값" prop="defaultValue">
          <el-input v-model="settingFormData.defaultValue" :disabled="true" />
        </el-form-item>
      </el-row>
      <!-- <el-row v-if="settingFormData.settingValue === 'true' || settingFormData.settingValue === 'false' || switchFlag === true "> -->
      <el-row v-if="isBoolean(settingFormData.settingValue) || isBoolean(settingFormData.defaultValue)">
        <el-form-item label="설정 값" prop="settingValue">
          <el-switch v-model="settingValueForSwitch" />
        </el-form-item>
      </el-row>
      <el-row v-else>
        <el-form-item label="설정 값" prop="settingValue">
          <el-input v-model="settingFormData.settingValue" :disabled="!activeSettingValue" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" class="mr-r4" type="solid" :disabled="!checkFlag" @click="onSavenButtonClick">저장</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import { clone, isEqual, findIndex, cloneDeep, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';

export default {
  name: 'WUpdateAgentPopup',
  props: {
    instanceId: Number,
    agentList: Array,
  },
  data() {
    return {
      settingValueForSwitch: false,
      originalSettingValueForSwitch: false,
      settingFormData: {},
      originalData: {},
      // switchFlag: false,
    };
  },
  computed: {
    checkFlag() {
      return !isEqual(this.settingFormData, this.originalData) || !isEqual(this.settingValueForSwitch, this.originalSettingValueForSwitch);
    },
    /**
     * 설정 ID가 'obj_name', 'obj_host_type', 'obj_host_name'이면 설정 값 변경 못함.
     * 적용/활성화 flag가 모두 true여야 설정 값 변경 가능.
     * @return {[type]} [description]
     * @author jda
     */
    activeSettingValue() {
      const data = this.settingFormData;
      const excludeConfig = ['obj_name', 'obj_host_type', 'obj_host_name'];
      return data.includeConfig && data.enableConfig && excludeConfig.indexOf(data.configId) < 0;
    },
  },
  watch: {
    /**
     * 적용/활성화 모두 true일 경우 설정 값에 기본 값 바인딩.
     * @param  {[type]} flag [description]
     * @return {[type]}      [description]
     * @author jda
     */
    activeSettingValue(flag) {
      const settingFormData = this.settingFormData;
      if (flag && isEmpty(settingFormData.settingValue)) {
        this.settingFormData.settingValue = settingFormData.defaultValue;
      }
    },
  },
  methods: {
    /**
     * 에이전트 설정 팝업을 띄우낟.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    open(record) {
      this.settingFormData = clone(record);
      if (this.settingFormData.settingValue === 'true') {
        this.settingValueForSwitch = true;
        this.originalSettingValueForSwitch = true;
      } else if (this.settingFormData.settingValue === 'false') {
        this.settingValueForSwitch = false;
        this.originalSettingValueForSwitch = false;
      }
      // console.log(this.settingFormData);
      // if (this.settingFormData.defaultValue === 'TRUE' || this.settingFormData.defaultValue === 'FALSE') {
      //   this.switchFlag = true;
      // } else {
      //   this.switchFlag = false;
      // }
      this.originalData = clone(record);
      this.$refs.slidingPopup.open();
    },
    /**
     * 에이전트 설정 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업 close 이벤트 핸들러
     * @return {[type]} [description]
     * @author jda
     */
    onClose() {
      this.$refs.settingForm.resetFields();
    },
    /**
     * 적용 플래그가 false일 경우 활성화 플래그도 false 설정.
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    changeIncludeConfig(value) {
      if (!value) {
        this.settingFormData.enableConfig = value;
      }
    },
    /**
     * 에이전트 설정을 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    onSavenButtonClick() {
      if (!this.activeSettingValue) {
        this.settingFormData.settingValue = this.originalData.settingValue;
        this.settingValueForSwitch = this.originalSettingValueForSwitch;
      }

      // 설정값이 boolean 값일 때만 다음 로직을 적용한다.
      if (this.isBoolean(this.settingFormData.settingValue)) {
        if (this.settingValueForSwitch === true) {
          this.settingFormData.settingValue = 'true';
        } else if (this.settingValueForSwitch === false) {
          this.settingFormData.settingValue = 'false';
        }
      }
      
      const settingData = this.settingFormData;
      const agentList = cloneDeep(this.agentList);
      const idx = findIndex(agentList, (data) => data.configId === settingData.configId);
      agentList[idx] = settingData;

      ApmSettingAPI.setConfigureWas({
        instanceId: this.instanceId,
        children: agentList,
      }).then((response) => {
        const result = response.data;
        if (result.success) {
          this.$emit('load');
          this.close();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '에이전트 설정', result.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '에이전트 설정', false));
      });
    },
    isBoolean(value) {
      const dataType = typeof value;
      let result = false;

      if (dataType === 'boolean') {
        result = true;
      } else if (dataType === 'string') {
        if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') {
          result = true;
        }
      }
      return result;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/UpdateAgentPopup.vue